<ion-content>
  <div class="login-wrapper">
    <div *ngIf="notice" class="auth-notice">
      {{ notice }}
    </div>
    <div class="logo-container">
      <img src="https://storage.googleapis.com/nutritionambition.app/logos/login-screen-logo.svg" alt="Nutrition Ambition Logo" class="login-logo clickable-logo" (click)="navigateToChat()" />
    </div>
    <div class="login-card">
      <h1 class="form-title">Log in</h1>
      
      <form (ngSubmit)="onLogin()">
        <div class="form-group">
          <label for="email" class="input-label">Email</label>
          <ion-input
            id="email"
            type="email"
            [(ngModel)]="email"
            name="email"
            class="input-box"
            required>
          </ion-input>
        </div>
        
        <div class="form-group">
          <label for="password" class="input-label">Password</label>
          <ion-input
            id="password"
            type="password"
            [(ngModel)]="password"
            name="password"
            class="input-box"
            required>
            <ion-input-password-toggle slot="end" color="medium"></ion-input-password-toggle>
          </ion-input>
        </div>
        
        <div class="forgot-password">
          <a (click)="onForgotPassword()" class="forgot-link">Forgot Password?</a>
        </div>
        
        <p class="form-legal">By using this app, you agree to our <a routerLink="/legal/terms-of-service" class="legal-link">Terms of Use</a> and <a routerLink="/legal/privacy-policy" class="legal-link">Privacy Policy</a>.</p>
        
        <ion-button expand="block" type="submit" color="tertiary" class="login-button" [disabled]="isWorking">
          Log in
        </ion-button>

        <ion-button expand="block" class="guest-login-button" [disabled]="isWorking" (click)="onContinueAsGuest()">
          Continue as Guest
        </ion-button>
      </form>
      
      <div class="form-footer">
        <a routerLink="/signup" class="form-footer-link">Don't have an account? Sign up!</a>
      </div>
    </div>

    
    <div class="copyright-text">
      Copyright © 2025–{{ currentYear }} Nutrition Ambition All rights reserved
    </div>
  </div>
</ion-content>
